.wrapper {
    grid-column: margin;
    justify-self: center;
    height: 0;
    overflow: visible;
    position: sticky;
    top: var(--spacer-16);
    z-index: 50;
}

.menu {
    position: relative;
    padding: var(--spacer-16) var(--spacer-40);
    border-radius: var(--border-radius-full);
    border: 1px solid var(--light-gray);
    background: var(--white);
    box-shadow: var(--box-shadow-3);

    &[data-overflow-left="true"]::before,
    &[data-overflow-right="true"]::after {
        content: "";
        position: absolute;
        inset-block: 0;
        width: var(--spacer-80);
        border-radius: var(--border-radius-full);
    }

    &[data-overflow-left="true"]::before {
        left: var(--spacer-32);
        background: linear-gradient(270deg, #fff0 0%, #fff 100%);
    }

    &[data-overflow-right="true"]::after {
        right: var(--spacer-32);
        background: linear-gradient(270deg, #fff 0%, #fff0 100%);
    }
}

.scrollContainer {
    display: flex;
    gap: var(--spacer-24);
    overflow-x: auto;
    max-width: calc(100vw - 2 * var(--spacer-margin));
    scrollbar-width: none;
}

.menuGroup {
    display: flex;
    gap: inherit;
}

.menuItem {
    composes: base from "../Clickables/index.module.scss";
    composes: fontST16 from "../../styles/typography.module.scss";
    color: var(--black);
    white-space: nowrap;

    &[data-hovered],
    &[data-focus-visible] {
        color: var(--red);
    }
}
